/**
 * "Narrow to one vendor" — the same filter on bookings, orders, reviews and
 * support requests, so the query lives here rather than four times over.
 */
import { api } from '@/lib/api';
import { EntityFilter, type EntityOption } from './entity-filter';

type VendorRow = { id: string; business_name: string | null; city: string | null };

async function search_vendors(term: string): Promise<EntityOption[]> {
  const res = await api.get<{ items: VendorRow[] }>('/admin/vendors', {
    params: { q: term, page_size: 10 },
  });
  return res.data.items.map((v) => ({
    id: v.id,
    title: v.business_name ?? v.id,
    subtitle: v.city,
  }));
}

async function load_vendor(id: string): Promise<EntityOption> {
  const res = await api.get<VendorRow>(`/admin/vendors/${id}`);
  return {
    id,
    title: res.data.business_name ?? id,
    subtitle: res.data.city,
  };
}

export function VendorFilter({
  vendor_id,
  on_change,
  label = 'Vendor',
}: {
  vendor_id: string;
  on_change: (id: string) => void;
  label?: string;
}) {
  return (
    <EntityFilter
      label={label}
      value={vendor_id}
      on_change={on_change}
      search={search_vendors}
      load_selected={load_vendor}
      placeholder="Business name…"
      test_id="vendor-filter"
    />
  );
}
